var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.0002H2.33333C1.97971 10.0002 1.64057 9.85969 1.39052 9.60964C1.14048 9.35959 1 9.02045 1 8.66683V2.66683C1 2.31321 1.14048 1.97407 1.39052 1.72402C1.64057 1.47397 1.97971 1.3335 2.33333 1.3335H8.33333C8.68696 1.3335 9.02609 1.47397 9.27614 1.72402C9.52619 1.97407 9.66667 2.31321 9.66667 2.66683V3.3335M7 6.00016H13C13.7364 6.00016 14.3333 6.59712 14.3333 7.3335V13.3335C14.3333 14.0699 13.7364 14.6668 13 14.6668H7C6.26362 14.6668 5.66667 14.0699 5.66667 13.3335V7.3335C5.66667 6.59712 6.26362 6.00016 7 6.00016Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d540a150e4790ee13d4fd2a38e94d8e1.svg";
export { ForwardRef as ReactComponent };